import Image from 'next/image';
import { Box, NoSsr } from '@mui/material';
import blogBgBlobLeft from '../assets/blogBgBlobLeft.svg';
import blogBgBlobRight from '../assets/blogBgBlobRight.svg';
import blogCoffeeCup from '../assets/blogCoffeeCup.svg';
import blogEarbuds from '../assets/blogEarbuds.svg';
import blogNotes from '../assets/blogNotes.svg';
import blogPencil from '../assets/blogPencil.svg';
export const BackgroundGraphics = () => <NoSsr data-sentry-element="NoSsr" data-sentry-component="BackgroundGraphics" data-sentry-source-file="BackgroundGraphics.tsx">
    <Box sx={{
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%'
  }} data-sentry-element="Box" data-sentry-source-file="BackgroundGraphics.tsx">
      <Box sx={{
      position: 'absolute',
      left: 0,
      top: -20
    }} data-sentry-element="Box" data-sentry-source-file="BackgroundGraphics.tsx">
        <Image src={blogBgBlobLeft} alt="" width={272} height={876} data-sentry-element="Image" data-sentry-source-file="BackgroundGraphics.tsx" />
      </Box>
      <Box sx={{
      position: 'absolute',
      left: 20,
      top: 158
    }} data-sentry-element="Box" data-sentry-source-file="BackgroundGraphics.tsx">
        <Image src={blogCoffeeCup} alt="" width={194} height={212} data-sentry-element="Image" data-sentry-source-file="BackgroundGraphics.tsx" />
      </Box>
      <Box sx={{
      position: 'absolute',
      left: 228,
      top: 99
    }} data-sentry-element="Box" data-sentry-source-file="BackgroundGraphics.tsx">
        <Image src={blogEarbuds} alt="" width={109} height={109} data-sentry-element="Image" data-sentry-source-file="BackgroundGraphics.tsx" />
      </Box>
      <Box sx={{
      position: 'absolute',
      left: 50,
      top: 392
    }} data-sentry-element="Box" data-sentry-source-file="BackgroundGraphics.tsx">
        <Image src={blogPencil} alt="" width={189} height={153} data-sentry-element="Image" data-sentry-source-file="BackgroundGraphics.tsx" />
      </Box>
      <Box sx={{
      position: 'absolute',
      top: 100,
      right: 0
    }} data-sentry-element="Box" data-sentry-source-file="BackgroundGraphics.tsx">
        <Image src={blogBgBlobRight} alt="" width={236} height={746} data-sentry-element="Image" data-sentry-source-file="BackgroundGraphics.tsx" />
      </Box>
      <Box sx={{
      position: 'absolute',
      top: 45,
      right: 0
    }} data-sentry-element="Box" data-sentry-source-file="BackgroundGraphics.tsx">
        <Image src={blogNotes} alt="" width={196} height={237} data-sentry-element="Image" data-sentry-source-file="BackgroundGraphics.tsx" />
      </Box>
    </Box>
  </NoSsr>;